import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { AuthLayout } from "./Login";

export function Forgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <AuthLayout title="Mot de passe oublié" subtitle="Recevez un lien de réinitialisation par e-mail.">
      {sent ? (
        <div data-testid="forgot-sent-msg" className="space-y-4 text-center">
          <p className="text-slate-700">Si un compte existe pour <b>{email}</b>, un e-mail vient d'être envoyé. Le lien est valable 1 heure.</p>
          <Link to="/login" className="btn-soft w-full">Retour à la connexion</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="label">Adresse e-mail</span>
            <input className="field" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </label>
          <button className="btn-primary w-full" data-testid="forgot-submit-btn">Envoyer le lien</button>
          <Link to="/login" className="block py-2 text-center text-sm font-semibold text-teal-700">Retour</Link>
        </form>
      )}
    </AuthLayout>
  );
}

export function Reset() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe modifié. Vous pouvez vous connecter.");
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <AuthLayout title="Nouveau mot de passe">
      <form onSubmit={submit} className="space-y-4">
        <label className="block">
          <span className="label">Nouveau mot de passe (8 caractères min.)</span>
          <input className="field" type="password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
        </label>
        <button className="btn-primary w-full" data-testid="reset-submit-btn">Enregistrer</button>
      </form>
    </AuthLayout>
  );
}
